import { render } from "./selectIdAndName.vue?vue&type=template&id=a3432aac"
import script from "./selectIdAndName.vue?vue&type=script&lang=js"
export * from "./selectIdAndName.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__